import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    LocationsServiceProxy,
    CreateOrEditLocationDto,
    LocationCompanyLookupTableDto,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    templateUrl: './create-or-edit-location.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditLocationComponent extends AppComponentBase implements OnInit {
    active = false;
    saving = false;

    location: CreateOrEditLocationDto = new CreateOrEditLocationDto();

    companyName = '';

    allCompanys: LocationCompanyLookupTableDto[];

    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('Location'), '/app/master/locations'),
        new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _locationsServiceProxy: LocationsServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.show(this._activatedRoute.snapshot.queryParams['id']);
    }

    show(locationId?: number): void {
        if (!locationId) {
            this.location = new CreateOrEditLocationDto();
            this.location.id = locationId;
            this.companyName = '';

            this.active = true;
        } else {
            this._locationsServiceProxy.getLocationForEdit(locationId).subscribe((result) => {
                this.location = result.location;

                this.companyName = result.companyName;

                this.active = true;
            });
        }
        this._locationsServiceProxy.getAllCompanyForTableDropdown().subscribe((result) => {
            this.allCompanys = result;
        });
    }

    save(): void {
        this.saving = true;

        this._locationsServiceProxy
            .createOrEdit(this.location)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this._router.navigate(['/app/master/locations']);
            });
    }

    saveAndNew(): void {
        this.saving = true;

        this._locationsServiceProxy
            .createOrEdit(this.location)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this.location = new CreateOrEditLocationDto();
            });
    }
    goBack(): void {
        this._router.navigate(['/app/master/locations']);
    }
}
